import { organizationClient, phoneNumberClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

const apiBase = new URL(process.env.VITE_API_BASE || '/kip', window.location.origin);

export const authClient = createAuthClient({
  baseURL: apiBase.origin,
  basePath: `${apiBase.pathname.replace(/\/$/, '')}/auth`,
  plugins: [phoneNumberClient(), organizationClient()],
});
